import Image from 'next/image';
import SimpleForm from 'react-scale/components/ui/simple-form';

const ContactBanner = () => (
  <section className="relative my-12 text-white md:pt-24 md:mt-24">
    <div className="container">
      <div
        className="flex flex-wrap items-center gap-12 px-10 py-10 md:px-20 md:flex-nowrap bg-codGray rounded-3xl"
        style={{ boxShadow: 'inset 0 4px 0 0 #262626' }}
      >
        <div className="w-full md:w-5/12">
          <Image
            width="400"
            height="400"
            src="/static/images/pages/homepage/contact/enterprise-ai.png"
          />
        </div>
        <div className="w-full md:w-7/12">
          <h4 className="mb-6 text-3xl font-normal md:font-light md:text-4xl lg:text-5xl font-aeonik lg:leading-tight">
            Interested in <br /> <span className="text-transform-gradient">Enterprise AI</span>{' '}
            <br /> for your industry?
          </h4>
          <p className="mb-12">Get in touch with our AI specialists for a scoping session.</p>
          <div className="xl:w-5/6">
            <SimpleForm duplicateId={3} />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactBanner;
